// const urlBackEnd = "https://www.test-t6dnbai-h5b47fjo5ugck.ovhcloud-fr-1.webpaas.ovh.net"

const urlBackEnd = "https://www.master-7rqtwti-h5b47fjo5ugck.ovhcloud-fr-1.webpaas.ovh.net"

// const urlBackEnd = "http://localhost:1338"

export default urlBackEnd;